<script lang="ts">
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zflow from '../../_common/z/zflow.svelte'
    import { faUser } from '@fortawesome/free-solid-svg-icons'

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()
    let show = false

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let gridA: GridClass = null
    let gridB: GridClass = null
    let gridC: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: any[] = await window.api.pos.reports.InvoicesPersonsAll(from, to)
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        console.log('relat.data', data)
        gridA = new GridClass()
        gridA.title = 'Curva ABC - A'
        gridB = new GridClass()
        gridB.title = 'Curva ABC - B'
        gridC = new GridClass()
        gridC.title = 'Curva ABC - C'
        //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
        gridA.cols.push(new GridCol({ content: 'Grupo', size: 1 }))
        gridA.cols.push(new GridCol({ content: 'Cliente' }))
        gridA.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        gridA.cols.push(new GridCol({ content: 'Última compra', type: GridColTypeEnum.date }))
        gridA.cols.push(new GridCol({ content: 'Valor comprado', type: GridColTypeEnum.float_2 }))
        gridA.cols.push(new GridCol({ content: 'Valor pago', type: GridColTypeEnum.float_2 }))
        gridA.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        gridB.cols.push(new GridCol({ content: 'Grupo', size: 1 }))
        gridB.cols.push(new GridCol({ content: 'Cliente' }))
        gridB.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        gridB.cols.push(new GridCol({ content: 'Última compra', type: GridColTypeEnum.date }))
        gridB.cols.push(new GridCol({ content: 'Valor comprado', type: GridColTypeEnum.float_2 }))
        gridB.cols.push(new GridCol({ content: 'Valor pago', type: GridColTypeEnum.float_2 }))
        gridB.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        gridC.cols.push(new GridCol({ content: 'Grupo', size: 1 }))
        gridC.cols.push(new GridCol({ content: 'Cliente' }))
        gridC.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        gridC.cols.push(new GridCol({ content: 'Última compra', type: GridColTypeEnum.date }))
        gridC.cols.push(new GridCol({ content: 'Valor comprado', type: GridColTypeEnum.float_2 }))
        gridC.cols.push(new GridCol({ content: 'Valor pago', type: GridColTypeEnum.float_2 }))
        gridC.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        let pos = 0
        for (const item of data) {
            pos++
            let grupo = 'C'
            if ((100 / data.length) * pos <= 50) grupo = 'B'
            if ((100 / data.length) * pos <= 20) grupo = 'A'
            let line: GridLine = new GridLine()
            line.slots.push({ content: grupo })
            line.slots.push({ content: item['person']?.name })
            line.slots.push({ content: item['person']?.phone })
            line.slots.push({ content: item.lastInvoice })
            line.slots.push({ content: item.total })
            line.slots.push({ content: item.totalPaid })
            line.slots.push({ content: [new GridButton({ callback: () => window.person('show', item.personId), icon: faUser })] })
            if (grupo === 'A') {
                gridA.lines.push(line)
            }
            if (grupo === 'B') {
                gridB.lines.push(line)
            }
            if (grupo === 'C') {
                gridC.lines.push(line)
            }
        }
        show = false
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <Zflow>
        <Grid class="h-space" grid={gridA} />
        <Grid grid={gridB} />
        <Grid grid={gridC} />
    </Zflow>
</div>
<LoadSpinner {show}></LoadSpinner>
